import { ApolloError } from 'apollo-client';
import { GraphQLError } from 'graphql';

import { type AGGError } from '@atlassian/relay-errors';

export class ApolloErrorInterop extends ApolloError {
	constructor(options: {
		graphQLErrors?: ReadonlyArray<GraphQLError | AGGError>;
		networkError?: Error | null;
		errorMessage?: string;
		extraInfo?: any;
	}) {
		const graphQLErrors = options.graphQLErrors?.map((error) => {
			if (error instanceof GraphQLError) {
				return error;
			}

			const message = error.message;
			const extensions = error.extensions;
			const path = error.path;
			const originalError = new Error(message, {
				cause: error,
			});

			const graphQLError = new GraphQLError(
				message,
				undefined,
				undefined,
				undefined,
				path,
				originalError,
				extensions,
			);
			Object.defineProperties(graphQLError, {
				nodes: {
					get() {
						throw new Error(`[Relay migration] 'nodes' is not supported yet`);
					},
				},
				source: {
					get() {
						throw new Error(`[Relay migration] 'source' is not supported yet`);
					},
				},
				positions: {
					get() {
						throw new Error(`[Relay migration] 'positions' is not supported yet`);
					},
				},
			});
			return graphQLError;
		});

		super({
			...options,
			graphQLErrors,
		});

		// Fix prototype chain for instanceof checks
		// This is necessary when extending Error-based classes in JavaScript
		Object.setPrototypeOf(this, ApolloErrorInterop.prototype);
	}
}
